

<template>
	<a class="hotspot" @click="onClick" :style="style" :class="`ic-${icon}`" v-tooltip.bottom="{content:label, classes:['hotspot']}">
		<i></i>
	</a>
</template>

<script>

import { EventBus } from '@/common/eventbus.js'
import { store } from '@/store'
import { mapState } from 'vuex'

export default {
	store,
	props: ['x', 'y', 'link', 'icon', 'label'],
	data: () => {
		return {
		}
	},
	computed: {
		...mapState('globals', ['app']),
		...mapState('settings', ['presets']),
		style: function () 	{
			return {
				top: (this.y - 2.5) + `%`,
				left: (this.x) + `%`
			}
		}
	},

	mounted() {
	},

	methods: {
		
		onClick( event ) {
			EventBus.$emit('hotspot-clicked', this.createEventParameters( event ) );
		},

		createEventParameters( event ) {
			return Object.assign({
				link: this.link,
				$el: this.$el,
				originalEvent: event,
			});
		}
	}

}
</script>

<style scoped lang="scss">

	$color-hotspot: #fff;

	.hotspot {
		position: absolute;
		width: 30px;
		height: 50px;
		padding: 30px;
		transform: translate( -50%, -50% );
		cursor: pointer;
		&:after {
			content: '';
			@include position( absolute, 100% auto auto 50%, 10, 40px, 40px );
			//background: rgba($color-hotspot,0.5);
			transform-origin: left top;
			border-radius: 100%;
			box-sizing: border-box;
			border: 1px solid rgba($color-hotspot,0);
			@include animation( pulse, 2000ms, 0, cubic-bezier(0.08, 0.71, 0.61, 0.99), infinite, forwards);
		}
		@media ($max-device-width-md) {
			width: 10px;
			height: 10px;
			&:after {
				width: 20px;
				height: 20px;
				@include animation( pulse-mobile, 1500ms, 0, cubic-bezier(0.08, 0.71, 0.61, 0.99), infinite, forwards);
			}
		}
	}

	i {
		@include position( absolute, 90% auto auto 50%, 15, 50px, 50px);
		background: transparent url(~@assets/images/ic-pin.svg) center center no-repeat;
		background-size: contain;
		transform: translate(-50%, -100%) rotateZ(0.1deg);
		filter: drop-shadow(0 0 3px rgba(#000, 0.2));
		transition: 0.2s all;
		padding: 10px 10px 30px 10px;
		&:after {
			content: '';
			@include position( absolute, 0 auto auto 0 );
			width: 100%;
			height: 65%;
			transform: translate(0, 9%);
			background-position: center center;
			background-repeat: no-repeat;
			background-size: contain;
		}
	}

	.hotspot:hover {
		i {
			transform: translate(-50%, -120%) rotateZ(0.1deg);
		}
		&:after {
			opacity: 0 !important;
		}
	}

	@keyframes pulse {
		0% { 
			transform: scale(0) translate( -50%, -50% );
			border: 40px solid rgba($color-hotspot,0);
			opacity: 0;
		}
		50% { 
			border: 10px solid rgba($color-hotspot,1);
			opacity: 1;
		}
		100% { 
			transform: scale(1, 0.3) translate( -50%, -50% );
			border: 0 solid rgba($color-hotspot,0);
			opacity: 0.5;
		}
	}
	
	@keyframes pulse-mobile {
		0% { 
			transform: scale(0) translate( -50%, -50% );
			border: 10px solid rgba($color-hotspot,0);
			opacity: 0;
		}
		50% { 
			border: 5px solid rgba($color-hotspot,0.6);
			opacity: 1;
		}
		100% { 
			transform: scale(1) translate( -50%, -50% );
			border: 0 solid rgba($color-hotspot,0);
			opacity: 0.5;
		}
	}

</style>
